import { Tag, colors } from '@sweep-io/sweep-design';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { AutoTemplatesStruct, automationTemplates } from '../../constants/automationTemplates';
import { ObjectTypeLabelAndKeyTag } from '../common/ObjectTypeLabelAndKey';
import useObjectTypesWithFetch from '../../hooks/useObjectTypesWithFetch';
import {
  PageTemplateActionButton,
  PageTemplateCard,
  PageTemplateGrid,
  PageTemplateHeaderWrapper,
  getColorForTemplateCard,
} from '../pages/pages-templates';
import { useAutomationsContext } from './AutomationsContext';

interface AutomationsTemplatesListProps {
  crmOrgId: string;
  automationVariant: AutomationFormVariant;
  onSelectTemplate: (item: AutoTemplatesStruct) => void;
  createEmptyButton: JSX.Element;
}

export const AutomationsTemplatesList = ({
  automationVariant,
  crmOrgId,
  createEmptyButton,
  onSelectTemplate,
}: AutomationsTemplatesListProps) => {
  const listOfTemplates = automationTemplates[automationVariant];
  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId });
  const dataByVariant = useAutomationsContext();

  return (
    <PageTemplateGrid>
      <PageTemplateCard
        stripeColor1={colors.grey[120]}
        actionsContent={createEmptyButton}
        description={`Custom ${dataByVariant.nameInMessageSingular}`}
        headerContent={<Tag label="Any object" color={colors.grey[120]} />}
        onCardClick={() => {
          (window as any).document.querySelector('#add-automation-button-wrapper button')?.click();
        }}
      />

      {listOfTemplates.map((item: AutoTemplatesStruct) => (
        <PageTemplateCard
          key={item.automation.name}
          stripeColor1={getColorForTemplateCard(item.automation.objectName)}
          actionsContent={
            <PageTemplateActionButton onClick={() => onSelectTemplate(item)}>
              Use template
            </PageTemplateActionButton>
          }
          description={item.automation.name || ''}
          headerContent={
            <PageTemplateHeaderWrapper
              firstItem={
                item.automation.objectName && (
                  <ObjectTypeLabelAndKeyTag
                    label={
                      objectTypesByName[item.automation.objectName]?.label ||
                      item.automation.objectName
                    }
                    objectType={item.automation.objectName}
                  />
                )
              }
              secondItem={item.icon}
            />
          }
          onCardClick={() => onSelectTemplate(item)}
        />
      ))}
    </PageTemplateGrid>
  );
};
